import { MainButtonVisualEnum } from '~/src/components/form-components/main-button/main-button-visual.enum';
import { TextAlign } from '~/src/components/common-components/popup-content/popup-content.types';
import { PHONE_NUMBER_VALIDATION_ERROR } from '~/src/models/constants/bad-request-errors.constants';
import { ActivationPromocodeResultPopupProps } from '~/src/components/common-components/activation-code-result-popup/activation-code-result-popup';
import { FONTS } from '~/src/styles/style-helpers/font-helper';
import { BAD_REQUEST_CODE, CONFLICT_CODE, SERVER_ERROR_CODE } from '~/src/models/constants/status-codes';

export const LEAD_POPUP_DATA = (id: number) => {
    return {
        title: `Создан лид № ${id || ''}`,
        width: 336,
        subButtonText: 'Посмотреть список лидов',
        subText: <>Подробности о новом лиде можно посмотреть на странице со&nbsp;списком&nbsp;лидов</>,
    };
};

export const LEAD_REFERRAL_POPUP_DATA = {
    title: 'Заявка отправлена',
    minWidth: 280,
    subButtonText: 'Закрыть',
    subText: (
        <>
            Мы свяжемся с вами в ближайший
            <br />
            рабочий день, с 9:00 до 18:00
        </>
    ),
    textAlign: 'center' as TextAlign,
    titleFontSize: FONTS.compact.medium.size20,
    subTitleFontSize: FONTS.compact.regular.size14,
    isShowIcon: true,
};

export const LEAD_REFERRAL_POPUP_ERROR_DATA = {
    title: 'Заявка отправлена',
    width: 464,
    subButtonText: 'Закрыть',
    subText: 'Спасибо! Скоро с вами свяжутся менеджеры МТС',
    isShowIcon: false,
};

export const LEAD_ALL_REFERRAL_POPUP_DATA = {
    title: 'Заявка на подключение отправлена',
    width: 464,
    subButtonText: 'Оформить ещё одну заявку',
    subText: (
        <>
            Спасибо! Скоро с вами свяжутся менеджеры МТС
            <br />
            <br />
            Вы можете оформить ещё одну заявку прямо сейчас. Для&nbsp;этого нажмите &laquo;Оформить ещё одну
            заявку&raquo;.
        </>
    ),
    isShowIcon: false,
};

export const LEAD_REFERRAL_POPUP_EXIST_DATA = {
    title: 'Такой лид уже есть',
    width: 496,
    mainButtonText: 'Создать новый лид',
    mainButtonType: MainButtonVisualEnum.secondary,
    subButtonText: 'Посмотреть список лидов',
    subText: (
        <>
            Лид не может быть создан повторно. Чтобы&nbsp;посмотреть подробности, перейдите на&nbsp;страницу
            со&nbsp;списком&nbsp;лидов
        </>
    ),
};

export const LEAD_NOT_AUTH_POPUP_DATA = (id: string) => ({
    title: `Создан лид № ${id || ''}`,
    width: 384,
    subButtonText: 'Создать новый лид',
    subText: <>Лид успешно передан в МТС</>,
});

export const LEAD_NOT_AUTH_POPUP_ERROR_DATA = (subText: string) => ({
    title: 'Лид не создан',
    width: 360,
    minWidth: 294,
    mainButtonText: 'Изменить данные',
    mainButtonType: MainButtonVisualEnum.primary,
    subText: subText,
    textAlign: 'center' as TextAlign,
});

export const REF_POPUP_ERROR_DATA = (subText: string) => ({
    title: 'Заявка не отправлена',
    width: 360,
    minWidth: 294,
    mainButtonText: 'Изменить данные',
    mainButtonType: MainButtonVisualEnum.primary,
    subText: subText,
    textAlign: 'center' as TextAlign,
});

export const REF_PHONE_NOT_VALID_POPUP_ERROR = {
    title: 'Заявка не отправлена',
    width: 360,
    minWidth: 294,
    mainButtonText: 'Изменить данные',
    mainButtonType: MainButtonVisualEnum.primary,
    subText: PHONE_NUMBER_VALIDATION_ERROR,
    textAlign: 'center' as TextAlign,
};

export const LEAD_NOT_AUTH_POPUP_EXIST_DATA = {
    title: 'Такой лид уже передан в МТС',
    width: 407,
    mainButtonText: 'Изменить данные',
    mainButtonType: MainButtonVisualEnum.primary,
    subText: <>Лид не может быть создан повторно</>,
};

export const LEAD_NOT_AUTH_POPUP_ERROR = {
    title: 'Ошибка',
    width: 542,
    minWidth: 294,
    mainButtonText: 'Ок',
    mainButtonType: MainButtonVisualEnum.primary,
    subText: <>Попробуйте отправить ещё раз</>,
    textAlign: 'center' as TextAlign,
};

export const ADDRESS_WITHOUT_FIAS_ID_POPUP_ERROR = {
    popupId: 'address without fias id',
    title: 'Недостаточно данных по адресу подключения',
    width: 542,
    minWidth: 294,
    mainButtonText: 'Ок',
    mainButtonType: MainButtonVisualEnum.primary,
    subText: (
        <>
            {
                'Для выбранного адреса отсутствует необходимая информация в адресном справочнике. \n Выберите соседний дом, а нужный адрес укажите в комментарии к лиду. Это позволит передать лид в МТС и доуточнить адрес подключения услуги при контакте с клиентом.'
            }
        </>
    ),
    textAlign: 'center' as TextAlign,
};

export const PHONE_NOT_VALID_POPUP_ERROR = {
    title: 'Лид не создан',
    width: 360,
    minWidth: 294,
    mainButtonText: 'Изменить данные',
    mainButtonType: MainButtonVisualEnum.primary,
    subText: PHONE_NUMBER_VALIDATION_ERROR,
    textAlign: 'center' as TextAlign,
};

export const PROMOTIONAL_CODE_RESPONSE_POPUP_ERROR = (text: string): ActivationPromocodeResultPopupProps => {
    return {
        iconName: 'ErrorIcon',
        title: 'Что-то пошло не так',
        text: text || '',
    };
};

export const PROMOTIONAL_CODE_POPUP_DATA = {
    successfulPopupContent: {
        iconName: 'SuccessIcon',
        title: 'Промокод активирован',
        text: (
            <>
                С вами свяжется менеджер МТС
                <br /> в будние дни с 9-18
            </>
        ),
    },
    alreadyExistsPopupContent: {
        iconName: 'AlreadyExistIcon',
        title: 'Промокод уже активирован',
        text: 'Этот промокод уже был активирован ранее',
    },
    somethingWrongPopupContent: {
        iconName: 'ErrorIcon',
        title: 'Что-то пошло не так',
        text: 'Попробуйте ещё раз позже',
    },
    notFoundPopupContent: {
        iconName: 'ErrorIcon',
        title: 'Промокод не найден',
        text: 'Проверьте, что вы ввели промокод без ошибок',
    },
    notValidPhonePopupContent: {
        iconName: 'ErrorIcon',
        title: 'Что-то пошло не так',
        text: PHONE_NUMBER_VALIDATION_ERROR,
    },
} as const;

export const PAGE_CONTEXT = {
    LEAD_NOT_AUTH: 'lead_not_auth',
    LEAD_REFERRAL: 'lead_referral',
    LEAD_ALL_REFERRAL: 'lead_all_referral',
    LEAD_MAIN: 'lead_main',
} as const;

export const ERROR_STATUS = {
    [BAD_REQUEST_CODE]: 'validation_error',
    [CONFLICT_CODE]: 'conflict',
    [SERVER_ERROR_CODE]: 'server_error',
    UNKNOWN_ERROR: 'unknown_error',
} as const;

export const TYPE_ERROR_ACTION = {
    popup: 'popup',
    chips: 'chips',
} as const;

export const POPUP_ERROR = {
    [PAGE_CONTEXT.LEAD_MAIN]: {
        validationError: LEAD_NOT_AUTH_POPUP_ERROR_DATA,
        phoneValidationError: PHONE_NOT_VALID_POPUP_ERROR,
    },
    [PAGE_CONTEXT.LEAD_NOT_AUTH]: {
        validationError: LEAD_NOT_AUTH_POPUP_ERROR_DATA,
        phoneValidationError: PHONE_NOT_VALID_POPUP_ERROR,
    },
    [PAGE_CONTEXT.LEAD_REFERRAL]: {
        validationError: REF_POPUP_ERROR_DATA,
        phoneValidationError: REF_PHONE_NOT_VALID_POPUP_ERROR,
    },
    [PAGE_CONTEXT.LEAD_ALL_REFERRAL]: {
        validationError: REF_POPUP_ERROR_DATA,
        phoneValidationError: REF_PHONE_NOT_VALID_POPUP_ERROR,
    },
};
